import React, { useState, useEffect } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Latex from 'react-latex-next';
import 'katex/dist/katex.min.css';
import { loadVolume } from '../data/volumes.js';
import CiteButton from './CiteButton.js';


const VolumePageContent = () => {
    const { year } = useParams();
    const [volume, setVolume] = useState([]);
    const [status, setStatus] = useState('loading'); // loading | ready | error

    // Fetch this year's articles on demand. Switching years fetches the new
    // file; coming back to one already visited is served from the cache.
    useEffect(() => {
        let active = true;
        setStatus('loading');

        loadVolume(year)
            .then((articles) => {
                if (!active) return;
                setVolume(articles);
                setStatus('ready');
            })
            .catch(() => {
                if (!active) return;
                setVolume([]);
                setStatus('error');
            });

        return () => {
            active = false;
        };
    }, [year]);

    return (
        <div>
            <section className="main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-text">
                                <h1>Volume {year}</h1>
                                <div className="bt-option">
                                    <NavLink to="/">Home</NavLink>
                                    <span>Volumes</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="volume-section spad">
                <div className="container">
                    {status === 'loading' && (
                        <div className="volume-status" role="status" aria-live="polite">
                            <div className="loader"></div>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="volume-status">
                            <p>This volume could not be loaded. Please try again.</p>
                        </div>
                    )}

                    {status === 'ready' && volume.length === 0 && (
                        <div className="volume-status">
                            <p>No articles have been published in this volume yet.</p>
                        </div>
                    )}

                    {status === 'ready' && volume.map((article) => (
                        <div key={article.documentName} className="section-title">
                            <h4><Latex>{article.title}</Latex></h4>
                            <div className="button-group">
                                <NavLink to={`/volumes/${year}/article/${article.documentName}`} className='view-btn'>View</NavLink>
                                <a href={article.path} download={article.documentName} target='_blank' rel="noreferrer">PDF</a>
                                <CiteButton article={article} siblings={volume} year={year} />
                            </div>
                            <p>{article.authors.map(author => author.name).join(', ')}</p>
                            <p>Published Online: {article.publishedOnline}</p>
                            <p>Page range: {article.pageRange}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default VolumePageContent;
